<template>
    <div>
        <div calss="">
            <HomeVue v-if="view == 'home' && $store.getters.get_company.id == 1" />
            <HomeVue v-if="view == 'home' && $store.getters.get_company.id == 3" />
            <HomeVue v-if="view == 'home' && $store.getters.get_company.id == 4" />
            <HomeCarbinoVue v-if="view == 'home' && $store.getters.get_company.id == 5" /> <!--Carbino -->

            <!-- <AsistenciaVue @setView="setView" v-if="view == 'asistencia'" /> -->
            <MaintenanceVue @setView="setView" v-if="view == 'mantenimiento'" />

            <CloseBeadVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 1" />
            <CloseBeadAqVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 3" />
            <CloseBeadVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 4" />
            <CloseBeadCarbinoVue @setView="setView" v-if="view == 'close_bead' && $store.getters.get_company.id == 5" />

            <ProccessVue v-if="view == 'proccess'" @mtdViewFooter="mtdViewFooter" @setView="setView" />
            <ReportView v-if="view == 'reports'" @mtdViewFooter="mtdViewFooter" @setView="setView" />
        </div>
        <FooterVue v-if="view == 'home'" :view="view" @setView="setView" />
    </div>
</template>

<script>
import FooterVue from "../../components/Vendedor/demo/Footer.vue";
import HomeVue from "../../components/Vendedor/demo/Home.vue";
import ProccessVue from '../proccess/ProccessView.vue';
import CloseBeadVue from "../../components/caja/demo/page/CloseBead.vue";
import CloseBeadAqVue from "../../components/caja/aq/page/CloseBead.vue";
import CloseBeadCarbinoVue from "../../components/caja/carbino/page/CloseBead.vue";
import MaintenanceVue from "../../views/maintenance/index.vue";
import ReportView from '../reports/ReportsView.vue';

import HomeCarbinoVue from "../../components/Vendedor/carbino/Home.vue";

// import AsistenciaVue from "../../components/asistencia/Asistencia.vue";


export default {
    components: { FooterVue, HomeVue, MaintenanceVue, ProccessVue, CloseBeadVue,CloseBeadAqVue, CloseBeadCarbinoVue, ReportView, HomeCarbinoVue},
    data() {
        return {
            view: "home",
        };
    },
    methods: {
        setView: function (payload) {
            this.view = payload;
        },
        mtdViewFooter: function (boo, view) {
            this.booFooter = boo;
            if (boo == true) this.view = view;
        }
    },
};
</script>

<style lang="scss" scoped></style>
